import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import CollectionCard from "@/components/feature/CollectionCard";
import { collections } from "@/mocks/collections";
import { collectionDetails } from "@/mocks/collectionDetails";

export default function CollectionDetailPage() {
  const { slug } = useParams();
  const item = collections.find((c) => c.slug === slug);
  const detail = item ? collectionDetails[item.id] : undefined;

  if (!item || !detail) {
    return (
      <Layout>
        <div className="container-site flex flex-col items-center py-24 text-center">
          <i className="ri-information-line text-4xl text-foreground-400"></i>
          <p className="mt-4 text-sm text-foreground-600">该合集暂时不存在或正在整理中。</p>
          <Link to="/collections" className="btn-primary mt-6">
            返回合集目录
          </Link>
        </div>
      </Layout>
    );
  }

  const related = collections.filter((c) => c.id !== item.id).slice(0, 3);

  return (
    <Layout>
      <section className="bg-background-100">
        <div className="container-site py-10 md:py-14">
          <nav className="flex flex-wrap items-center gap-1 text-xs text-foreground-500" aria-label="面包屑">
            <Link to="/" className="hover:text-primary-700">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/collections" className="hover:text-primary-700">合集</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-700">{item.title}</span>
          </nav>

          <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="lg:col-span-1">
              <div className="sticky top-24 overflow-hidden rounded-lg border border-background-200/70 bg-background-50">
                <img
                  src={item.cover}
                  alt={`${item.title}合集封面`}
                  className="aspect-[3/4] w-full object-cover object-top"
                />
                <div className="flex flex-col gap-3 p-5">
                  <span className="chip w-fit">
                    <i className="ri-price-tag-3-line mr-1"></i>
                    {item.tag}
                  </span>
                  <dl className="space-y-2 text-sm">
                    <div className="flex justify-between">
                      <dt className="text-foreground-500">类别</dt>
                      <dd className="text-foreground-800">{item.category}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-foreground-500">系列</dt>
                      <dd className="text-foreground-800">{item.series}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-foreground-500">整理者</dt>
                      <dd className="text-foreground-800">{item.author}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-foreground-500">条目数</dt>
                      <dd className="text-foreground-800">{item.count}</dd>
                    </div>
                    <div className="flex justify-between">
                      <dt className="text-foreground-500">更新</dt>
                      <dd className="text-foreground-800">{item.updated}</dd>
                    </div>
                  </dl>
                  <Link to="/archive" className="btn-primary w-full">
                    <i className="ri-archive-line mr-2"></i>
                    查归档列表
                  </Link>
                </div>
              </div>
            </div>

            <div className="lg:col-span-2">
              <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {item.title}
              </h1>
              <p className="mt-4 text-sm leading-6 text-foreground-600 md:text-base">
                {detail.intro}
              </p>

              <div className="mt-8 space-y-8">
                {detail.sections.map((sec) => (
                  <section key={sec.title}>
                    <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-900">
                      <i className="ri-corner-down-right-line text-primary-600"></i>
                      {sec.title}
                    </h2>
                    <p className="mt-2 text-sm leading-6 text-foreground-600">
                      {sec.body}
                    </p>
                  </section>
                ))}
              </div>

              <section className="mt-10 rounded-lg border border-background-200/70 bg-background-50 p-6">
                <h3 className="font-heading text-base font-bold text-foreground-900">
                  本合集目录
                </h3>
                <ol className="mt-4 space-y-3">
                  {detail.chapters.map((chapter, i) => (
                    <li
                      key={chapter}
                      className="flex items-center gap-3 text-sm text-foreground-700"
                    >
                      <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs font-medium text-secondary-800">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {chapter}
                    </li>
                  ))}
                </ol>
              </section>

              <aside className="mt-8 rounded-lg border border-primary-200 bg-primary-50/70 p-6">
                <h3 className="flex items-center gap-2 text-sm font-semibold text-primary-900">
                  <i className="ri-file-info-line"></i>
                  整理说明
                </h3>
                <ul className="mt-3 space-y-2 text-sm text-foreground-700">
                  {detail.notes.map((note) => (
                    <li key={note} className="flex items-start gap-2">
                      <i className="ri-checkbox-circle-line mt-0.5 text-primary-600"></i>
                      {note}
                    </li>
                  ))}
                </ul>
              </aside>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="container-site py-12 md:py-16">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            相关合集推荐
          </h2>
          <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {related.map((rel) => (
              <CollectionCard key={rel.id} item={rel} />
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}